import { useEffect } from "react"
import { useInView } from "react-intersection-observer"
import { Typography } from "@/components/Typography"

interface Props {
  hasNextPage: boolean
  isFetchingNextPage: boolean
  onLoadMore: () => void
}

export const InfiniteScrollTrigger = ({
  hasNextPage,
  isFetchingNextPage,
  onLoadMore,
}: Props) => {
  const { ref, inView } = useInView({
    threshold: 0,
    rootMargin: "350px",
  })

  useEffect(() => {
    if (inView && hasNextPage && !isFetchingNextPage) {
      onLoadMore()
    }
  }, [inView, hasNextPage, isFetchingNextPage, onLoadMore])

  if (!hasNextPage) return null

  return (
    <div ref={ref} className="h-10 leading-10 text-center">
      <div>Loading more...</div>
    </div>
  )
}
